/** The community gallery. */
export const community = {
  copyFailed: 'Couldn’t copy this design',
  searchGallery: 'Search the gallery',
  title: 'Community',
  subtitle: {
    one: '{count} design people published to copy and remix',
    other: '{count} designs people published to copy and remix',
  },
  sort: 'Sort',
  trending: 'Trending',
  newest: 'Newest',
  shelf: 'Shelf',
  allCount: 'All · {count}',
  shelfCount: '{shelf} · {count}',
  categoryWebsite: 'Websites',
  categoryApp: 'Web apps',
  categoryDashboard: 'Dashboards',
  categoryMobile: 'Mobile',
  categoryMarketing: 'Marketing',
  categoryOther: 'Other',
  emptyTitle: 'Nothing on the shelves yet',
  emptyDescription:
    'Anyone can list a canvas here from its Share menu — people preview it and copy it into their own account, and the original stays private. Be the first.',
  pickCanvas: 'Pick a canvas to publish',
  visibleOf: '{visible} of {total}',
  noMatch: 'Nothing matches — try a different search or shelf.',
  noPreview: 'no preview',
  frames: '{count} frames',
  byAuthor: 'by {name}',
  copies: { one: '{count} copy', other: '{count} copies' },
  copying: 'Copying…',
  useThis: 'Use this',
  published: 'by {name} · published {time} · {copies}',
  copyNote: 'Copies land in your canvases as a private copy — edit freely, the original is untouched.',
  copyToMine: 'Copy to my canvases',
} as const
